import React from 'react';
import { ABOUT_ME, SKILL_GROUPS, STATS, PERSONAL_INFO } from '../constants/data';

const About = () => {
  return (
    <section id="about" className="section about reveal">
      <div className="container">
        <div className="section-head">
          <span className="section-head__index">01</span>
          <h2 className="section-head__title">About</h2>
        </div>

        <div className="about__grid">
          <div className="about__bio">
            <p className="about__lead">{ABOUT_ME.intro}</p>
            <p className="about__para">{ABOUT_ME.details}</p>
            <p className="about__availability">
              <span className="accent-mono">→</span> {PERSONAL_INFO.availability}
            </p>

            <div className="about__stats">
              {STATS.map((stat) => (
                <div key={stat.label} className="about__stat">
                  <span className="about__stat-value">{stat.value}</span>
                  <span className="about__stat-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="about__skills">
            {SKILL_GROUPS.map((group) => (
              <div key={group.title} className="skill-group">
                <h3 className="skill-group__title">{group.title}</h3>
                <div className="skill-group__list">
                  {group.skills.map((skill) => (
                    <span key={skill} className="chip">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
